import CloseIcon from "@mui/icons-material/Close";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import { format, parseISO } from "date-fns";
import { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";
import { useApiMutation } from "../hooks/useApi";
import { TimeSheet } from "../types/timesheet";

interface Props {
  unapproveOpen: boolean;
  handleUnapproveClose: () => void;
  timesheet: TimeSheet;
}

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
}));

const UnapproveTimesheetDialog: FunctionComponent<Props> = (
  props: Props
): JSX.Element => {
  const { handleUnapproveClose, unapproveOpen, timesheet } = props;
  const { apiUpdate } = useApiMutation();

  const { t } = useTranslation();

  const handleUnapproveSave = async () => {
    const status = 2;

    apiUpdate.mutate(
      {
        entity: "timesheets",
        post: {
          id: timesheet?.id,
          status: status,
        },
      },
      {
        onSuccess: () => handleUnapproveClose(),
        onError: (error) => console.error(error),
      }
    );
  };
  return (
    <BootstrapDialog
      onClose={handleUnapproveClose}
      aria-labelledby="customized-dialog-title"
      open={unapproveOpen}
    >
      <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
        {t("dialogs.unapproveDialog.title")}
      </DialogTitle>
      <IconButton
        aria-label="close"
        onClick={handleUnapproveClose}
        sx={{
          position: "absolute",
          right: 8,
          top: 8,
          color: (theme) => theme.palette.grey[500],
        }}
      >
        <CloseIcon />
      </IconButton>

      <DialogContent>
        <Typography>
          {t("dialogs.unapproveDialog.text", { candidate: timesheet.candidate, weekEnding: format(parseISO(timesheet.weekEnding), "dd/MM/yyyy") })}
        </Typography>
      </DialogContent>

      <DialogActions>
        <Button autoFocus onClick={handleUnapproveClose}>
          {t("buttons.cancel")}
        </Button>
        <Button variant="contained" onClick={handleUnapproveSave}>
          {t("buttons.unapprove")}
        </Button>
      </DialogActions>
    </BootstrapDialog>
  );
};

export default UnapproveTimesheetDialog;
